// extracted by mini-css-extract-plugin
export default {"container_generate":"GenerateImage_container_generate__O5tqm","input":"GenerateImage_input__Fqik3"};